import React from "react";
import { Helmet } from "react-helmet-async";
import ScrollToTopButton from "../components/ScrollToTopButton";

const PricingAndRefundPolicy = () => {
  return (
    <>
      <div className="min-h-screen bg-white py-8 px-2 md:py-12 md:px-4">
        <Helmet>
          <title>Pricing & Refund Policy | VOICE</title>
          <meta
            name="description"
            content="Pricing, security deposit, cancellation and refund policy for VOICE (EV91Technologies)."
          />
        </Helmet>

        <div className="max-w-3xl mx-auto bg-white/90 rounded-lg shadow-lg p-4 md:p-8 text-gray-800">
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-green-800">
            Pricing & Refund Policy
          </h1>

          <p className="mb-4 text-gray-700">
            Last updated: June 21, 2025
          </p>

          <p className="mb-6 text-gray-700">
            This Pricing & Refund Policy explains the rental charges, security
            deposit requirements, cancellation rules, and refund timelines for
            riders using services provided by{" "}
            <strong>VOICE (EV91Technologies Pvt Ltd)</strong>.
          </p>

          {/* Pricing */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Rental Pricing
          </h2>

          <p className="mb-4 text-gray-700">
            VOICE provides electric vehicle rentals on a weekly rental basis.
          </p>

          <p className="mb-4 text-gray-700">
            The weekly rental charges range between{" "}
            <strong>₹1,280 to ₹1,600</strong>, depending on the vehicle type and
            rental plan selected.
          </p>

          <p className="mb-4 text-gray-700">
            Rental charges must be paid in advance to continue using the vehicle.
          </p>

          {/* Security Deposit */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Security Deposit
          </h2>

          <p className="mb-4 text-gray-700">
            A <strong>refundable security deposit of ₹2,500</strong> is mandatory
            for all riders.
          </p>

          <p className="mb-4 text-gray-700">
            Riders may initially pay <strong>₹1,000</strong>. The remaining
            amount may be supported or adjusted by the company as per internal
            policy.
          </p>

          {/* Minimum Working Period */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Minimum Working Period for Refund
          </h2>

          <p className="mb-4 text-gray-700">
            To be eligible for a security deposit refund, the rider must have
            actively worked with the company for a minimum of{" "}
            <strong>90 days</strong>.
          </p>

          <p className="mb-4 text-gray-700">
            Riders who exit before completing 90 days will not be eligible for a
            security deposit refund.
          </p>

          {/* Exit Policy */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Exit & Cancellation Policy
          </h2>

          <p className="mb-4 text-gray-700">
            Riders who wish to exit the company must inform VOICE at least{" "}
            <strong>7 days in advance</strong>.
          </p>

          <p className="mb-4 text-gray-700">
            Exit is subject to vehicle return, document verification, and
            clearance of all pending dues.
          </p>

          {/* Refund Timeline */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Refund Timeline (TAT)
          </h2>

          <p className="mb-4 text-gray-700">
            In case of an eligible cancellation or approved security deposit
            refund, the refund amount will be credited to the original payment
            method.
          </p>

          <p className="mb-4 text-gray-700">
            <strong>
              Refunds will be processed within 7 working days
            </strong>{" "}
            after completion of all required checks and formalities.
          </p>

          {/* Deductions */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Deductions
          </h2>

          <p className="mb-4 text-gray-700">
            Any pending rental charges, damages, penalties, or policy violations
            may be deducted before processing the refund.
          </p>

          {/* Contact */}
          <h2 className="text-2xl font-semibold mt-8 mb-2 text-green-800">
            Contact Us
          </h2>

          <p className="mb-4 text-gray-700">
            If you have any questions regarding pricing or refunds, you can
            contact us:
          </p>

          <ul className="list-disc ml-6 text-gray-700 mb-4">
            <li>Email: info@ev91riderz.com</li>
            <li>
              Address: Site No. 23, A.V.S. Compound, 80 Feet Rd, 4th Block,
              Koramangala, Bengaluru, Karnataka – 560095
            </li>
          </ul>
        </div>

        <ScrollToTopButton />
      </div>
    </>
  );
};

export default PricingAndRefundPolicy;
